<div class="container">
  <!--  <div class="header">-->
  <!--    <app-back-button>Back to my orders</app-back-button>-->
  <!--  </div>-->

  <div class="content">
    <div class="content__banner">
      <!--        [userCard]="orderDetails().billing_address."-->
      <!--        deliveryDropoff="Hand it to me / Meet at the door"-->

      <!--        TODO: Ask backend FIX is_asap field -->
      @let shippingAddress = orderDetails()?.shipping_address;
      @let deliveryAddress =
        [
          shippingAddress?.address_1,
          shippingAddress?.address_2,
          shippingAddress?.city,
          shippingAddress?.state,
          shippingAddress?.postcode
        ]
          .filter(Boolean)
          .join(', ');

      <app-order-thank-you-card
        [orderNumber]="orderDetails()?.order_number!"
        [userEmail]="(orderDetails()?.billing_address)!.email"
        [deliveryAddress]="deliveryAddress || ''"
        [deliveryDropoffInstructions]="orderDetails()?.customer_note!"
        [paymentMethod]="orderDetails()?.payment_method_title || ''"
        [deliveryDate]="deliveryDate()"
        [isPickup]="isPickup()"
      />
    </div>

    <div class="content__cart">
      <h3 class="content__cart-title">Items Ordered</h3>

      <div class="content__cart-list">
        @for (product of orderDetails().products; track product.id) {
          <app-order-cart-item
            [name]="product.name!"
            [price]="product.subtotal"
            [count]="product.quantity"
            [addOns]="product.item_meta || []"
            [variantName]="product.variant_name"
          />
        }
      </div>
    </div>

    <div class="content__prices">
      <app-order-prices-card
        [taxes]="orderDetails().totals.tax_lines?.[0]?.tax_total || 0"
        [deliveryFee]="orderDetails().totals.shipping_total || 0"
        [tip]="orderDetails().totals.fee_lines[0]?.total || 0"
        [couponCode]="orderDetails().totals.discount_total || 0"
        [points]="0"
        [subtotal]="subtotal()"
        [total]="orderDetails().totals.total || 0"
      />
    </div>
  </div>
</div>
